import * as React from 'react';
import {PrismicRichText} from '@prismicio/react';

import {ContentBlockSlice} from '../cms.types';

export interface ContentBlockProps {
    slice: ContentBlockSlice;
}

export const ContentBlock = ({slice}: ContentBlockProps) => {
    /**
     * Returns alignment class based on slice
     */
    const getAlignClass = () => {
        if (slice.primary.text_align === 'Center') {
            return ` tw-text-center`;
        }
        return ` tw-text-left`;
    };

    /**
     * Template
     */
    return (
        <div
            className={`tw-flex tw-flex-col md:tw-flex-row tw-mb-6 tw-w-full${getAlignClass()}${
                slice.primary.text_color ? ' ' + slice.primary.text_color : ''
            }`}
        >
            {slice.primary.inline_image?.url ? (
                <>
                    <div
                        className={`tw-relative md:tw-px-[15px] md:tw-max-w-[50%] tw-p-0${
                            slice.primary.align_image ? ' tw-order-1 tw-ml-0 md:tw-ml-10' : ' tw-order-[0] tw-mr-0 md:tw-mr-10'
                        }`}
                    >
                        <img
                            alt={slice.primary.inline_image.alt}
                            className="tw-mb-6 tw-max-w-full tw-h-auto"
                            height={slice.primary.inline_image.dimensions.height}
                            src={slice.primary.inline_image.url}
                            width={slice.primary.inline_image.dimensions.width}
                        />
                    </div>
                    <div className="tw-relative md:tw-px-[15px] md:tw-max-w-[50%]">
                        <PrismicRichText field={slice.primary.body_copy} />
                    </div>
                </>
            ) : (
                <div>
                    <PrismicRichText field={slice.primary.body_copy} />
                </div>
            )}
        </div>
    );
};
